class API {
  constructor(API_IDENTIFICATOR, API_DOMAIN, STOREFRONT_API_ACCESS_TOKEN, API_VERSION, STOREFRONT_API_ACCESS_TOKEN_HEADER_KEY) {
    this.APIS = [
      'storefront',
      'ajax',
      'klaviyo'
    ];

    if (this.APIS.includes(API_IDENTIFICATOR)) {
      this.API_IDENTIFICATOR = API_IDENTIFICATOR;
    } else {
      // error
      console.log('API error: Unsupported API_IDENTIFICATOR: ', API_IDENTIFICATOR);
      return;
    }

    // You can still override the necessary parameters if you will work with another API
    this.API_DOMAIN = API_DOMAIN || `${routes.shop_url}`;
    this.STOREFRONT_API_ACCESS_TOKEN = STOREFRONT_API_ACCESS_TOKEN || 'b5baa1f603f45e6801f31ede4791d267';
    this.API_VERSION = API_VERSION || '2022-10';
    this.STOREFRONT_API_ACCESS_TOKEN_HEADER_KEY = STOREFRONT_API_ACCESS_TOKEN_HEADER_KEY || 'X-Shopify-Storefront-Access-Token';
    // end of You can still override the necessary parameters if you will work with another API

    this.GET = 'GET';
    this.POST = 'POST';
  }

  async request(method, route, body, isFormData) {
    const apiURL = this.API_DOMAIN + route;
    const headers = {
      'Content-Type': isFormData ? 'application/x-www-form-urlencoded' : 'application/json',
    };

    const isStorefrontAPIandHaveAcessToken = this.API_IDENTIFICATOR === 'storefront' && this.STOREFRONT_API_ACCESS_TOKEN;
    if (isStorefrontAPIandHaveAcessToken) {
      headers[this.STOREFRONT_API_ACCESS_TOKEN_HEADER_KEY] = this.STOREFRONT_API_ACCESS_TOKEN;
    }

    let requestBody;
    if (isFormData) {
      requestBody = new URLSearchParams();
      for (const key in body) {
        requestBody.append(key, body[key]);
      }
    } else {
      requestBody = JSON.stringify(body);
    }

    const response = await fetch(
      apiURL,
      {
        method: method,
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers,
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: requestBody,
      }
    );
    const data = await response.json();
    return data;
  }

  async getCart() {
    const route = '/cart.js';
    const data = await this.request(this.GET, route);
    return data;
  }

  async getProducts(queries, fields, countryCode) {
    let queryString = "";
    for (const [index, key] of Object.keys(queries).entries()) {
      queryString += key + ':' + (typeof queries[key] === 'string' ? '"' : '') + queries[key] + (typeof queries[key] === 'string' ? '"' : '');
      if (index != Object.keys(queries).length - 1) queryString += ",";
    }
    const query = `
    query allProducts @inContext(country: ${countryCode}){
      products(${queryString}) {
        pageInfo {
          hasNextPage
        }
        edges {
          cursor
          node ${fields}
        }
      }
    }`;
    const route = `/api/${this.API_VERSION}/graphql.json`;
    const body = { query };
    const response = await this.request(this.POST, route, body);
    return response;
  }

  async cartAdd(body) {
    const route = '/cart/add.js';
    const data = await this.request(this.POST, route, body);
    return data;
  }
}
